import { render } from "./FormPostales.vue?vue&type=template&id=6cf50ebc&scoped=true"
import script from "./FormPostales.vue?vue&type=script&lang=js"
export * from "./FormPostales.vue?vue&type=script&lang=js"

import "./FormPostales.vue?vue&type=style&index=0&id=6cf50ebc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cf50ebc"

export default script